import { createAsyncThunk } from "@reduxjs/toolkit";
// Utilities
import HttpClient from 'utilities/HttpClient';

export default class ReservationRequestsAsync {
  private static _url:string = '/client/reservationRequests';
  private static _http:HttpClient = new HttpClient();

  // Fetch reservation requests
  public static fetchReservationRequests = createAsyncThunk('reservationRequests/fetchReservationRequests', async (params:any, thunkApi) => {
    const response:Response = await this._http.get(this._url, params);
    if ( !response.ok ) return thunkApi.rejectWithValue(({...await response.json(), status: response.status}) as any);
    return response.json();
  });

  // Create reservation request
  public static createReservationRequest = createAsyncThunk('reservationRequests/createReservationRequest', async (data:any, thunkApi) => {
    const response:Response = await this._http.post(this._url, data);
    if ( !response.ok ) return thunkApi.rejectWithValue(({...await response.json(), status: response.status}) as any);
    return response;
  });

  // Create reservation request anonymous
  public static createReservationRequestAnonymous = createAsyncThunk('reservationRequests/createReservationRequest', async (data:any, thunkApi) => {
    const response:Response = await this._http.post(`${this._url}/anonymous`, data);
    if ( !response.ok ) return thunkApi.rejectWithValue(({...await response.json(), status: response.status}) as any);
    return response;
  });
}
